import { ActionIcon, AppShell, Burger, Center, Group, Image, List, MantineProvider, Paper, ScrollArea, Text } from "@mantine/core";
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { useDisclosure } from "@mantine/hooks";
import '@mantine/notifications/styles.css';
import { IconX } from "@tabler/icons-react";
import { navigate } from 'gatsby';
import React, { useEffect, useState } from "react";
// import '../../css/FloatingNavbar.css';
import { Notifications } from "@mantine/notifications";
import '../../css/style.css';
import { Location } from "../../global";
import { useLanguageNavigator } from "../../hooks";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from '../../hooks/ReduxHooks';
import { down, family, location, logo_white, search, up } from "../../images";
import { loadAuthFromStorage, logout } from "../../redux/authSlice";
import { setSelectedInterest, setSelectedLocation } from "../../redux/sys-slice";
import { availableLanguages, navTranslations, theme } from "../api";
import LangBar from "../LangBar";
import { UserButton } from "../UserButton/UserButton";
import MyFooter from "./MyFooter";
import { BtnMariam } from "./Support";
/* https://platform.deepseek.com/api_keys: sk-28f9a5b497ab44a1b31196dd910e1ea1 */
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const dispatch = useDispatch()
	// const { loading, error, success, userType } = useSelector(state => { return state.auth });
	// const { language }: { language: 'en' | 'ar' } = useLanguageNavigator(availableLanguages) // : { language: 'en' | 'ar' }
	const { lang } = useLanguageNavigator(availableLanguages)
	const locations:Location[] | null= useSelector(state => state.sys.locations);
	const isLoggedIn:boolean= useSelector(state => state.auth.isLoggedIn);
	const selectedLocation:Location | null= useSelector(state => state.sys.selectedLocation);
	const si:string= useSelector(state => state.sys.selectedInterest);
	useEffect(() => {dispatch(loadAuthFromStorage()) }, [dispatch]);
	const [isOpen, setIsOpen] = useState(false);
	const mbValue = 22
	const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  	const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(false);
	const localLocations = [{id: 1, name: "Doha", name_ar: "الدوحة"}, {id: 2, name: "Wakra", name_ar: "الوكرة"}]
	const locationClick = (loc: Location) => {
		dispatch(setSelectedLocation(loc))
		setIsOpen(false)
		navigate(lang == 'en'? `/salons/${loc.id}` : `/ar/salons/${loc.id}`)
	}
	const hide = () => {
		toggleDesktop()
		toggleMobile() 	// window.location.reload(); // Reload to trigger new API
	}
	const handleSelect = (type: string) => {
		localStorage.setItem("salonCategory", type);
		dispatch(setSelectedInterest(type));
		hide()
		navigate(lang == 'en' ? "/" : "/ar");
	};
	const handleLogoClick = () => { 
		dispatch(setSelectedLocation(null))
		navigate(lang == "en" ? `/` : `/${lang}/`) 
	}
	const handleLoginClick = () => {
		if (typeof window !== "undefined") {
			localStorage.setItem("redirectAfterLogin", window.location.pathname) // Save current page before redirecting to login
			hide()
			navigate("/auth/login");
		}
	};
	const [showProfileMenu, setShowProfileMenu] = useState(false);
	const t = lang === "ar"
		? { myProfile: "ملفي الشخصي", login: "تسجيل دخول / أشتراك" }
		: { myProfile: "My Profile", login: "Login / Create Account" };

	const  menuItems = [
		{ label: lang === "ar" ? "التعلييقات" : "Reviews", path: "/reviews" },
		{ label: lang === "ar" ? "المفضلة" : "Favorite", path: "/favorites" },
		{ label: lang === "ar" ? "دعوة صديق" : "Invite Friend", path: "/invite" },
		{ label: lang === "ar" ? "المحفظة" : "Wallet", path: "/wallet" },
		{ label: lang === "ar" ? "اقترح مكانا" : "ٍSuggest a place", path: "/place" },
		{ label: lang === "ar" ? "اتصل بنا" : "Contact Us", path: "/contact" },
		{ label: lang === "ar" ? "الإشعارات" : "Notifications", path: "/notifications" },
		{ label: lang === "ar" ? "الحساب" : "Account", path: "/profile" },
		{ label: lang === "ar" ? "تسجيل الخروج" : "Logout", path: "/logout" },
	];

	const handleNavigate = (path: string, num:number) => {
		setShowProfileMenu(false);
		hide()
		if(num === 8){dispatch(logout()); navigate("/");}
		else navigate(lang === "ar" ? `/ar${path}` : path);
	};
	// const myImg = "https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-8.png"
	// const myImg = typeof window !== "undefined" ? localStorage.getItem("picture") ?? "" : ""
	const searchClick = () => {
		localStorage.setItem("search-return-path", window.location.pathname)
		navigate(lang == 'en' ? '/search' : '/ar/search')
	}
	return (
		<MantineProvider theme={theme}>
			<Notifications position="bottom-left" zIndex={2077} limit={5}/>
			<AppShell 
				header={{ height: 50, }}
				navbar={{ width: 250, breakpoint: 'sm', collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },}}
			>
				<AppShell.Header style={{ background:'#000000ff'}}>
					<div style={{ display:'flex', height:'100%', justifyContent:'space-between', alignItems:'center', width:'100%'}}>
						<div style={{ display:'flex'}}>
							<Group h="100%" px="md">
								<Burger opened={mobileOpened} size="27" color={'white'} onClick={toggleMobile} hiddenFrom="sm" />
								<Burger opened={desktopOpened} size="27" color={'white'} onClick={toggleDesktop} visibleFrom="sm" />
							</Group>
							<Image src={logo_white} alt="up" h={35} mr={-10} ml={-10} mt={2} onClick={handleLogoClick} style={{ cursor:'pointer' }}/>
						</div>
						<div style={{ display:'flex'}}>
							<Group h="100%">								
								<div className="lang-bar">
									<div className="lang-button" onClick={() => setIsOpen((prev) => !prev)}>
										<Image src={location} alt="up" h={12} mr={7} ml={7} mt={1}/>
										<Text size="xl" c={'#EFD893'} style={{ fontFamily: 'Montserrat' }} fz={'h5'} ml={2} mr={2} mt={1} fw={500}>
											{
												selectedLocation != null ? 
												(lang == 'en'? selectedLocation.name : selectedLocation.name_ar) 
												: lang == 'en'? "Locations" : "المناطق"
											}
										</Text>
										{isOpen ? <Image src={up} alt="up" h={10} mr={7} ml={7} mt={2}/> : <Image src={down} alt="down" h={10} mr={7} ml={7} mt={2}/>}
									</div>
									{isOpen && (
										<div className="lang-dropdown">
											{
												locations != null && locations.length > 0 ?
												locations.map((loc) => (
												<div key={loc.id} className="lang-item" onClick={() => locationClick(loc)}>
													<Text ml={10} c={'white'} fz={'h4'} style={{ fontFamily: 'Montserrat' }}>
														{lang == 'en'? loc.name : loc.name_ar}
													</Text>
												</div>
												))
												:
												localLocations.map((loc) => (
												<div key={'loc1'} className="lang-item" onClick={() => setIsOpen(false)}>
													<Text ml={10} c={'white'} fz={'h4'} style={{ fontFamily: 'Montserrat' }}>{lang == 'en'? loc.name : loc.name_ar}</Text>
												</div>
												))
											}
										</div>
									)}
								</div>
							</Group>
							<Image src={search} alt="logo" h={20} mt={7} mr={10} ml={10} onClick={searchClick} style={{ cursor:"pointer" }}/>
						</div>
					</div>
				</AppShell.Header>
				<AppShell.Navbar style={{ background:'rgb(0, 0, 0)' }}>
					{/* <AppShell.Section h={80} style={{ display: "flex", alignItems: "center", justifyContent: "center", borderBottom:"2px solid white" }}><LangBar /></AppShell.Section> */}
					<AppShell.Section grow component={ScrollArea}>
						<LangBar />
						<Center mb={mbValue} mt={12}><Image src={family} alt="logo" radius={'md'} w={145} /></Center>
						<BtnMariam selected={si == "Ladies"} name={navTranslations[lang].ladies} mb={mbValue} onclick={() => handleSelect("Ladies")} font={lang == 'ar'? 20:28}/>
						<BtnMariam selected={si == "Gents"} name={navTranslations[lang].gents} mb={mbValue} onclick={() => handleSelect("Gents")} font={lang == 'ar'? 20:28}/>
						<BtnMariam selected={si == "Kids"} name={navTranslations[lang].kids} mb={mbValue} onclick={() => handleSelect("Kids")} font={lang == 'ar'? 20:28} />
						<BtnMariam selected={si == "Pets"} name={navTranslations[lang].pets} mb={mbValue} onclick={() => handleSelect("Pets")} font={lang == 'ar'? 20:28}/>
					</AppShell.Section>
					<AppShell.Section h={80} style={{ display: "flex", alignItems: "center", justifyContent: "center", borderTop:"2px solid white", color:"#CDAA62"}}>
						<Center>
						{
							// <Text c={"#c9a365"} fw={250} fz={16} style={{ cursor: "pointer" }} onClick={() => setShowProfileMenu((v) => !v)}>{t.myProfile}</Text>
							isLoggedIn ? (<UserButton onClick={() => setShowProfileMenu((v) => !v)}/>)
							: (<Text c={"#c9a365"} fw={250} fz={16} style={{ cursor: "pointer" }} onClick={handleLoginClick} >{t.login}</Text>)
						}
						</Center>
						{/* PROFILE OVERLAY MENU */}
						{showProfileMenu && (
							<Paper shadow="md" p="md" radius="0" bg={'white'}
								style={{position: "absolute", top:0, left: 0, right: 0, bottom: 80,height:'100%',}}
							>
								<ActionIcon variant="subtle" mt={12} onClick={()=>setShowProfileMenu(false)}><IconX color="black"/></ActionIcon>
								<List spacing="md" styles={{ root: { padding: "20px", cursor: "pointer" } }} >
									{menuItems.map((item, index) => (
										<List.Item key={index} icon={<div style={{ width: "18px", height: "18px", borderRadius: "50%", border: "2px solid black"}}/>}>
											<Text size="lg" fw={600} c="#c9a365" onClick={() => handleNavigate(item.path, index)}>{item.label}</Text>
										</List.Item>
									))}
								</List>
							</Paper>
						)}
					</AppShell.Section>
				</AppShell.Navbar>
				<AppShell.Main >
					{children}
					<MyFooter />
				</AppShell.Main>
			</AppShell>			
		</MantineProvider>
    )
}

export default Layout

								/* <Stack gap="xs">
									{menuItems.map((item, index) => (
									<div key={index}>
										<Text fz={16} fw={250} c="#CDAA62" style={{ cursor: "pointer", padding: "8px 0" }}onClick={() => handleNavigate(item.path)}>
											{item.label}
										</Text>
										{index !== menuItems.length - 1 && (<Divider color="rgba(255,255,255,0.1)" />)}
									</div>
									))}
								</Stack> */


// export const ImageWithText: React.FC<ImageWithTextProps> = ({ imageSrc, label, onClick }) => {
// 	return (
// 		<div
// 			onClick={onClick}
// 			style={{ height: `60px`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer", position: "relative", transition: "transform 0.2s" }}
// 			onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.95)" }}
// 			onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)" }}
// 		>
// 			<img src={imageSrc} alt="icon" style={{ height: "70%", objectFit: "contain" }} />
// 			{label && (
// 				<p style={{ fontFamily: "Montserrat, sans-serif", color: "black", fontSize: "12px", marginTop: "0px", textAlign: "center",}}>{label}</p>
// 			)}
// 		</div>
// 	);
// };

/* <div className="body-bg" style={{backgroundImage: `url(${bgArray[bg]})`}}> */
/* <div className="body-bg" style={{backgroundImage: `url(${bgArray[0]})`}}> */
/* <div className="body-bg" style={{background: `linear-gradient(169deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 49%, rgba(0,212,255,1) 100%)`}}> */
/* <div className="body-bg" style={{background: `rgb(255, 255, 255)`}}> */
/* <div className="body-bg" style={{background: `rgb(0, 0, 0)`}}> */

/* 
 Login Modal
 const { login, userRole } = useAuth()    
	const fw = 700 
	const lang = lang === "en" ? "/" : `/${language}/`
	
 const [isModalOpen, setIsModalOpen] = useState(false)
	const onClose = () => setIsModalOpen(false)
	const { width } = useViewportSize()
	const loginData = {
		title: { en: 'Customer Login', ar: 'تسجيل دخول العميل' },
		description: { en: 'Only authorized customers can log in to track their business.', ar: 'يمكن فقط للعملاء المصرح لهم تسجيل الدخول لمتابعة أعمالهم.' },
		emailLabel: { en: 'Email', ar: 'الإيميل' },
		emailPlaceholder: { en: 'Enter your email', ar: 'أدخل الإيميل' },
		passwordLabel: { en: 'Password', ar: 'كلمة المرور' },
		passwordPlaceholder: { en: 'Enter your password', ar: 'أدخل كلمة المرور' },
		loginButton: { en: 'Login', ar: 'تسجيل الدخول' },
		forgotPassword: { en: 'If you can\'t remember your password or have any other issues, please', ar: 'إذا لم تتمكن من تذكر كلمة المرور الخاصة بك أو لديك أي مشاكل أخرى، فيرجى' },
		contactUs: { en: 'contact us', ar: 'التواصل معنا' },
		cancel: { en: 'Cancel', ar: 'إلغاء' },
		loadingData: { en: 'Logging in...', ar: 'جارى التسجيل...' }
	};
	const [email, setEmail] = useState('');
  	const [password, setPassword] = useState('');
	
 const handleLogin = async () => {
		const resultAction = await dispatch(loginAdmin({ email, password }));
		if (loginAdmin.fulfilled.match(resultAction)) {
			login('admin'); // Set the role to 'admin' after successful login
			onClose(); // Close the modal
		}
	};
	<Modal
				opened={isModalOpen} onClose={onClose} centered size="md" radius="lg"
				closeOnClickOutside={false} // Prevent closing by clicking outside
				closeOnEscape={false} // Prevent closing by pressing Escape
				withCloseButton={false} // Remove the default close button
				overlayProps={{ opacity: 0.8, }} // Semi-transparent overlay
			>
				<Container> 
					<Center><Title c={"ss.9"} order={3} mb="sm">{loginData['title'][language]}</Title></Center>
					<Text c={"ss.8"} mb="xl">{loginData['description'][language]}</Text>
					<TextInput onChange={(e) => setEmail(e.currentTarget.value)} c={"ss.8"} label={loginData['emailLabel'][language]} placeholder={loginData['emailPlaceholder'][language]} required mb="md"/>
					<PasswordInput onChange={(e) => setPassword(e.currentTarget.value)} c={"ss.8"} label={loginData['passwordLabel'][language]} placeholder={loginData['passwordPlaceholder'][language]} required mb="xl"/>
					{error && (<Text c="red" mb="md">{error}</Text>)}
					// <Button fullWidth size="md" mb="md" color={"ss"} radius="md">{loginData['loginButton'][language]}</Button>
					<Button fullWidth size="md" mb="md" color={"ss"} radius="md" onClick={handleLogin} disabled={loading}>
						{loading ? loginData['loadingData'][language] : loginData['loginButton'][language]}
					</Button>
					<Text c={"ss.8"} mb="sm">
						{loginData['forgotPassword'][language]}{" "}
						<Text fw={700} c={"ss.8"} style={{ textDecoration: "underline" }} component={Link} to={`${lang}contactUs`} onClick={onClose}>
							{loginData['contactUs'][language]}
						</Text>.
					</Text>
					<div style={{ display: "flex", justifyContent: "end" }}>
						<Button variant="outline" color="red" onClick={onClose}>{loginData['cancel'][language]}</Button>
					</div>
				</Container>
			</Modal>
*/
{/* <Menu shadow="md" width={200}>
								<Menu.Target>
									<Image src={logo_white} alt="up" h={35} mr={-10} ml={-10} mt={2} onClick={() => setIsLogo((prev) => !prev)}/>
								</Menu.Target>
								<Menu.Dropdown>
									<Menu.Label>Application</Menu.Label>
        							<Menu.Item leftSection={<IconSettings size={14} />}>About Us</Menu.Item>
        							<Menu.Item leftSection={<IconSettings size={14} />}>Contact Us</Menu.Item>
        							<Menu.Item leftSection={<IconSettings size={14} />}>Terms & Conditions</Menu.Item>
								</Menu.Dropdown>
							</Menu> */}
/*
const sectionStyle = {
		backgroundImage: `url(${bga})`, // Set the background image
		backgroundSize: '90% auto',                // Control the size (e.g., 30% width, auto height)
		backgroundRepeat: 'no-repeat',             // Prevent the image from repeating
		backgroundColor: 'black',                  // Optional: Set a background color
		backgroundAttachment: 'fixed',             // Fix the image to the viewport
		backgroundPosition: '0% 80%',              // Position at top-left (adjust if needed)
	};
	const btmBarClick = (e: number) => {
		console.log("Clicked ", e)
		switch (e) {
			case 1: navigate(language == 'en'? `/` : `/ar/`); break;
			case 3: navigate(language == 'en'? `/wallet` : `/ar/wallet`); break;
			case 4: navigate(language == 'en'? `/profile` : `/ar/profile`); break;
			default: navigate(language == 'en'? `/` : `/ar/`); break;
		}
	}
<div className="body-bg">
			</div> 
<AppShell.Footer style={{ background:'rgb(255, 255, 255)', borderTopLeftRadius: "27px", borderTopRightRadius: "27px", }}>
					<Group grow mt={5} justify="space-around" align="center" h="100%">
						<ImageWithText imageSrc={btn_home} label="Home" onClick={() =>btmBarClick(1)}/>
						<ImageWithText imageSrc={bell} label="Notifications" onClick={() =>btmBarClick(2)}/>
						<ImageWithText imageSrc={btn_wallet} label="Wallet" onClick={() =>btmBarClick(3)}/>
						<ImageWithText imageSrc={btn_profile} label="Profile" onClick={() =>btmBarClick(4)}/>
					</Group>
				</AppShell.Footer> */
